export default function maxOrderBaseGetter(lignes) {
  if (!lignes || lignes.length === 0) return 0;
  const lignesOrder = lignes.map((ligne) => {
    return ligne.ordre;
  });
  return Math.max(...lignesOrder) / 100;
}
